var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-card',{ref:"card",attrs:{"title":_vm.title,"actions":_vm.actions,"handler":_vm.handlerClick}},[_c('v-text-field',{attrs:{"label":_vm.label,"type":"datetime-local","hide-details":"auto"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }